import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoadOverlay from "./utils/loadOverlay";
import LazyLoadRetry from "./utils/lazyLoadRetry";
import { paths } from "./constants";
import { Provider } from "react-redux";
import store from "./store";
import useDatalayer from "./hooks/useDatalayer";

const ForgotPasswordLegacy = React.lazy(() =>
  LazyLoadRetry(() => import("./core/ForgotPassword"))
);
const ChangePassword = React.lazy(() => import("./core/ChangePassword"));
const ForgotUserid = React.lazy(() =>
  LazyLoadRetry(() => import("./core/ForgotUserid"))
);
const UpdateProfile = React.lazy(() =>
  LazyLoadRetry(() => import("./core/UpdateProfile"))
);
const ValidatePasswordLink = React.lazy(() =>
  LazyLoadRetry(() => import("./core/ValidatePasswordLink"))
);
const FpdChangePassword = React.lazy(() =>
  LazyLoadRetry(() => import("./core/FpdChangePassword"))
);
const FpdResetPassword = React.lazy(() =>
  LazyLoadRetry(() => import("./core/FpdResetPassword"))
);
const GetUsername = React.lazy(() =>
  LazyLoadRetry(() => import("./core/GetUsername"))
);
const Registration = React.lazy(() =>
  LazyLoadRetry(() => import("./core/Registration"))
);
const RegistrationSQA = React.lazy(() =>
  LazyLoadRetry(() => import("./core/UpdateSQA"))
);
const Registrationv1 = React.lazy(() =>
  LazyLoadRetry(() => import("./core/Registrationv1"))
);
const AccountUnlock = React.lazy(() =>
  LazyLoadRetry(() => import("./core/AccountUnlock"))
);
const AccountUnlockLink = React.lazy(() =>
  LazyLoadRetry(() => import("./core/AccountUnlockLink"))
);
const AutoProvision = React.lazy(() => LazyLoadRetry(() => import('./core/AutoProvision')));
const HealthProbe = React.lazy(() => LazyLoadRetry(() => import('./healthprobe/HealthProbe')));
const DemoSite = React.lazy(() => LazyLoadRetry(() => import("./core/DemoSite")));
const VerifyPhone = React.lazy(() => LazyLoadRetry(() => import("./application/Pages/VerifyPhone/VerifyPhone")));
const ForgotPassword = React.lazy(() => LazyLoadRetry(() => import("./application/Pages/ForgotPassword/ForgotPassword")));
const ValidatePasswordSid = React.lazy(() =>
  LazyLoadRetry(() => import("./core/ValidatePasswordSid"))
);

const RoutesLocal = () => {
  const datalayer = useDatalayer();

  useEffect(() => {
    datalayer.addAdobeScript();
  }, []);

  return (
    <Suspense fallback={<LoadOverlay overlay={true}></LoadOverlay>}>
      <BrowserRouter>
        <Provider store={store}>
          <Routes>
            <Route path="/cusc/cpd">
              <Route path="" element={<ChangePassword />} />
              <Route path=":branding" element={<ChangePassword />} />
            </Route>
            <Route path="/cusc/fpd">
              <Route path="" element={<FpdChangePassword />} />
              <Route path=":branding" element={<FpdChangePassword />} />
            </Route>
            <Route path="/cusc/fuid">
              <Route path="" element={<ForgotUserid />} />
              <Route path=":branding" element={<ForgotUserid />} />
            </Route>
            {process.env.REACT_APP_FEATURE_FLAG_VERIFY_PHONE === 'false' && (
              <Route path="/cusc/fpwd-ini" element={<ForgotPasswordLegacy />}>
                <Route path="" element={<ForgotPasswordLegacy />} />
                <Route path=":branding" element={<ForgotPasswordLegacy />} />
              </Route>
            )}
            <Route path="/cusc/upf">
              <Route path="" element={<UpdateProfile />} />
              <Route path=":branding" element={<UpdateProfile />} />
            </Route>
            <Route path="/cusc/profile">
              <Route path="" element={<UpdateProfile />} />
              <Route path=":branding" element={<UpdateProfile />} />
            </Route>
            <Route path="/cusc/fpwd-vl">
              <Route path="" element={<ValidatePasswordLink />} />
              <Route path=":branding" element={<ValidatePasswordLink />} />
            </Route>
            <Route path="/cusc/fpd-reset">
              <Route path="" element={<FpdResetPassword />} />
              <Route path=":branding" element={<FpdResetPassword />} />
            </Route>
            <Route path="/cusc/fuid-vl">
              <Route path="" element={<GetUsername />} />
              <Route path=":branding" element={<GetUsername />} />
            </Route>
            <Route path="/cusc/registration">
              <Route path="" element={<Registration />} />
              <Route path=":branding" element={<Registration />} />
            </Route>
            <Route path="/cusc/sqa">
              <Route path="" element={<RegistrationSQA />} />
              <Route path=":branding" element={<RegistrationSQA />} />
            </Route>
            <Route path="/cusc/registrationv1/:crgroute" element={<Registrationv1 />} />
            <Route path="/cusc/accountunlock/:accountunlockroute" element={<AccountUnlock />} />
            <Route path="/cusc/accountunlock-vl/:accountunlocklinkroute" element={<AccountUnlockLink />} />
            <Route path="/cusc/autoprovision" element={<AutoProvision />} />
            {process.env.REACT_APP_FEATURE_FLAG_VERIFY_PHONE === 'true' && (
              <>
                <Route path={paths.VERIFY_PHONE} element={<VerifyPhone />} />
                <Route path={paths.FORGOT_PASSWORD}>
                  <Route path="" element={<ForgotPassword />} />
                  <Route path=":branding" element={<ForgotPassword />} />
                </Route>

              </>
            )}
            <Route path="/health/healthprobe" element={<HealthProbe />} />
            <Route path="/ciam/demo" element={<DemoSite />} />
            <Route path="/cusc/fpwd-vsid" element={<ValidatePasswordSid/>}/>
          </Routes>
        </Provider>
      </BrowserRouter>
    </Suspense>
  );
};

export default RoutesLocal;